module.exports = __webpack_public_path__ + "media/application/images/2023/02_still-925x520-4acef362939aedab909fa0cf652aa8dc.png";